export const useLocalePath = slug => {
    // const locale = useLocale()
    if(!slug) return ""
    if (slug === "" || slug === "/") return `/`
    else if (slug[slug.length - 1] === "/") return `/${slug}`
    else return `/${slug}/`
}